import { Injectable } from "@angular/core";
import { AlulaDatabaseService, AlulaResponseData } from "@app/shared/databases/alula.database";
import { DataServiceError } from "@app/shared/services/data-service-error";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AlulaReceiverGroup, AlulaReceiverGroupHelper } from "../model/alula-receiver-group";

@Injectable({
    providedIn: "root",
})
export class AlulaReceiverGroupDbService {
    constructor(private databaseService: AlulaDatabaseService) {}

    createAlulaReceiverGroup(receiverGroup: AlulaReceiverGroup): Observable<any> {
        return this.databaseService.createRecord$(AlulaReceiverGroupHelper.dbEndpoint, receiverGroup).pipe(
            map((_receiverGroup: AlulaResponseData) => AlulaReceiverGroupHelper.fromDbObject(_receiverGroup)),
            catchError(DataServiceError.handleError())
        );
    }

    updateAlulaReceiverGroup(receiverGroup: any, id: string): Observable<any> {
        const _receiverGroup = AlulaReceiverGroupHelper.toDbObject(receiverGroup);
        return this.databaseService.updateRecord$(AlulaReceiverGroupHelper.dbEndpoint, _receiverGroup, id).pipe(
            map((alulaReceiverGroup: AlulaResponseData) => AlulaReceiverGroupHelper.fromDbObject(alulaReceiverGroup)),
            catchError(DataServiceError.handleError())
        );
    }

    getAlulaReceiverGroups() {
        return this.databaseService.getRecords$(AlulaReceiverGroupHelper.dbEndpoint).pipe(
            map((groups = []) => groups.map(group => AlulaReceiverGroupHelper.fromDbObject(group))),
            catchError(DataServiceError.handleError())
        );
    }
    getAlulaReceiverGroupsByDealerId(dealerId: string) {
        return this.databaseService.getRecords$(AlulaReceiverGroupHelper.dbEndpoint, { dealerId }).pipe(
            map((groups = []) => groups.map(group => AlulaReceiverGroupHelper.fromDbObject(group))),
            catchError(DataServiceError.handleError())
        );
    }

    getAlulaReceiverGroupById(id: string) {
        return this.databaseService.getRecord$(AlulaReceiverGroupHelper.dbEndpoint, id);
    }

    deleteAlulaReceiverGroup(id: string) {
        return this.databaseService.deleteRecord$(AlulaReceiverGroupHelper.dbEndpoint, id);
    }

    getAlulaReceiversForGroup(id: string) {
        return this.databaseService.getRecords$(AlulaReceiverGroupHelper.dbEndpoint + `/${id}/binds?include=receiver`);
    }
}
